var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('settings-element',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(_vm._s(_vm.title))]},proxy:true},{key:"body",fn:function(){return [_c('Overflow',{attrs:{"variable":_vm.variable}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }